/** Biomas da Ilha da Encruzilhada (doc 04, Biomas). Uma única função classifica para todos os sistemas. */
export const BIOME = {
  mar: 0,
  praia: 1,
  mangue: 2,
  mata: 3,
  cerrado: 4,
  serra: 5,
} as const;
export type Biome = (typeof BIOME)[keyof typeof BIOME];
export const BIOME_NAMES = ["mar", "praia", "mangue", "mata", "cerrado", "serra"] as const;

/** tan(32°), tan(20°), tan(8°): declives comparados pelo gradiente, sem trigonometria. */
const SLOPE_SERRA = 0.6248693519093275;
const SLOPE_PRAIA = 0.36397023426620234;
const SLOPE_MANGUE = 0.14054083470239145;

export const MOISTURE_SPLIT = 0.45;
export const MOISTURE_MANGUE = 0.68;

export interface BiomeInput {
  /** Altura em metros (nível do mar = 0). */
  y: number;
  /** Umidade em [0, 1]. */
  moisture: number;
  /** Módulo do gradiente da altura (tangente do declive). */
  slope: number;
  /** Distância até o mar, em metros (0 na água). */
  coastDistance: number;
  /** Distância até a terra, em metros (0 em terra). */
  landDistance: number;
}

/** Mangue na água só nesta faixa junto à terra; evita "mangue" em plataforma rasa aberta. */
const MANGUE_MAX_LAND_DISTANCE = 24;

/** Regras avaliadas em ordem (doc 04): serra, mangue, praia, mata/cerrado, mar. */
export function classifyBiome({ y, moisture, slope, coastDistance, landDistance }: BiomeInput): Biome {
  if (y >= 45 || (y >= 3 && slope >= SLOPE_SERRA)) return BIOME.serra;
  if (
    y >= -1.5 &&
    y <= 1.5 &&
    moisture >= MOISTURE_MANGUE &&
    slope < SLOPE_MANGUE &&
    coastDistance < 120 &&
    landDistance <= MANGUE_MAX_LAND_DISTANCE
  ) {
    return BIOME.mangue;
  }
  if (y >= 0 && y < 3 && slope < SLOPE_PRAIA) return BIOME.praia;
  if (y >= 0) {
    if (y < 3) return BIOME.praia;
    return moisture >= MOISTURE_SPLIT ? BIOME.mata : BIOME.cerrado;
  }
  return BIOME.mar;
}
